import React, { Component } from "react";
import RenderTable from "../common/table";
import { Icon, Label } from "semantic-ui-react";
import auth from "../../services/authService";

class ProjectTable extends Component {
  columns = [
    {
      path: "id",
      label: "Sr#",
      width: "1",
    },
    {
      path: "company_name",
      label: "Client / Company",
      width: "4",
    },
    {
      path: "project_name",
      label: "Project",
      width: "4",
    },
    {
      path: "mobile_tel",
      label: "Mobile/Tel",
      width: "2",
    },
    {
      path: "project_code",
      label: "Project Code",
      width: "2",
    },
    {
      path: "status",
      label: "Status",
      width: "1",
      content: (type) =>
        type.status == 1 ? (
          <Label color="green">Active</Label>
        ) : type.status == 0 ? (
          <Label color="red">Stopped</Label>
        ) : (
          <Label color="green">Completed</Label>
        ),
    },
    {
      key: "actions",
      width: "2",
      content: (type) => (
        <div>
          <React.Fragment>
            {auth.getCurrentUser().email ===
              "client-unblocker@gondalgroup.ae" && (
              <React.Fragment>
                <Icon
                  name={type.status == 1 ? "hide" : "eye"}
                  color={type.status == 1 ? "black" : "green"}
                  className="clickable"
                  onClick={() => this.props.onStatusUpdate(type)}
                />

                <Icon
                  name="trash"
                  color="red"
                  className="clickable"
                  onClick={() => this.props.onDelete(type)}
                />
              </React.Fragment>
            )}
            <Icon
              name="edit"
              color="blue"
              className="clickable"
              onClick={() => this.props.onUpdate(type)}
            />
          </React.Fragment>

          <Icon
            name="info"
            color="blue"
            className="clickable"
            onClick={() => this.props.onDetail(type)}
          />
        </div>
      ),
    },
  ];

  render() {
    const { types, onSort, sortColumn } = this.props;

    return (
      <RenderTable
        columns={this.columns}
        data={types}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default ProjectTable;
